// Removes any spaces and sets to lowercase
function toKebabCase(label) {
    return label.replace(/\s+/g, '-').toLocaleLowerCase();
}

export default toKebabCase;
